/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 割引マスタ検索情報
 */
export interface Szza030aRequestDiscntMasterSrchInfDto { 
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string | null;
    /**
     * 商品コード：英数字
     */
    goodsCode?: string | null;
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode?: string | null;
    /**
     * 割引指定区分１：数字
     */
    discntSiteiDiv1?: string | null;
    /**
     * 割引指定区分２：数字
     */
    discntSiteiDiv2?: string | null;
    /**
     * 割引指定区分３：数字
     */
    discntSiteiDiv3?: string | null;
    /**
     * 割引指定区分４：数字
     */
    discntSiteiDiv4?: string | null;
    /**
     * 割引指定区分５：数字
     */
    discntSiteiDiv5?: string | null;
    /**
     * 割引範囲開始値：数字<br>　精度(3)
     */
    discntRangeStart?: number | null;
    /**
     * 適用開始日付（From）：日付(yyyyMMdd)
     */
    applyStartDateFrom?: string | null;
    /**
     * 適用開始日付（To）：日付(yyyyMMdd)
     */
    applyStartDateTo?: string | null;
    /**
     * 適用終了日付（From）：日付(yyyyMMdd)
     */
    applyEndDateFrom?: string | null;
    /**
     * 適用終了日付（To）：日付(yyyyMMdd)
     */
    applyEndDateTo?: string | null;
    /**
     * 割引正式名称：全角
     */
    discntAname?: string | null;
    /**
     * 割引略称名称：全角
     */
    discntRyaku?: string | null;
    /**
     * 割引範囲終了値：数字<br>　精度(3)
     */
    discntRangeEnd?: number | null;
    /**
     * 割引タイプコード：数字<br>　画面項目ID＝\'C011553\'
     */
    discntType?: string | null;
}

